import { supabase } from '../lib/supabase';
import { Countdown } from '../types/database';

export async function processRecurringCountdowns(countdowns: Countdown[]): Promise<void> {
  const now = new Date();
  now.setHours(0, 0, 0, 0);

  for (const countdown of countdowns) {
    if (!countdown.is_recurring) continue;

    const [year, month, day] = countdown.event_date.split('-').map(Number);
    const eventDate = new Date(year, month - 1, day);
    eventDate.setHours(0, 0, 0, 0);

    if (eventDate >= now) continue;

    const nextYearDate = new Date(year + 1, month - 1, day);
    nextYearDate.setHours(0, 0, 0, 0);

    if (nextYearDate <= now) continue;

    const nextYearStr = `${year + 1}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

    const { data: existing } = await supabase
      .from('countdowns')
      .select('id')
      .eq('user_id', countdown.user_id)
      .eq('name', countdown.name)
      .gte('event_date', nextYearStr)
      .maybeSingle();

    if (!existing) {
      await supabase.from('countdowns').insert({
        user_id: countdown.user_id,
        name: countdown.name,
        event_date: nextYearStr,
        emoji: countdown.emoji,
        color: countdown.color,
        category: countdown.category,
        is_recurring: true,
      });
    }
  }
}